import NextImage from 'next/image';

import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  width: calc(50% - 0.5rem);
  padding: 0.5rem 0 1.25rem 0;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0.75rem;
    right: 0.75rem;
    bottom: 0;
    pointer-events: none;
    border-radius: 8px;
    background: ${({ theme }) => theme.tokens.colors.neutral[100]};
    box-shadow: 0px 5px 10px -7px rgba(0, 0, 0, 0.2);
  }
`;

export const ImageWrapper = styled.div`
  overflow: hidden;
  position: relative;
  height: 0;
  margin-bottom: 1.25rem;
  padding-bottom: 54.9%;
  border-radius: 6px;
  background: ${({ theme }) => theme.tokens.colors.neutral[100]};
  box-shadow:
    0px 10px 30px 0px rgba(0, 0, 0, 0.15),
    0px 5px 20px -10px rgba(0, 0, 0, 0.6),
    0px 10px 30px -12px rgba(0, 0, 0, 0.3);
`;

export const Image = styled(NextImage)`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 6px;
  object-fit: cover;
`;

export const BottomContent = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.75rem;
`;

export const CardTitle = styled.span`
  color: ${({ theme }) => theme.tokens.colors.text[100]};
  text-overflow: ellipsis;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5rem;
`;
